/*
 * @Description: file content
 * @Author: ljrong
 * @Date: 2024-09-12 18:19:04
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2025-03-13 10:55:28
 */
import Cookies from "js-cookie";

export const DOMAIN_TOKEN_KEY = "myhometoken";
export const COWORK_DOMAIN_TOKEN_KEY = "cowork";


function isLocal() {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0';
}
function getDomain() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.').reverse();
  const domain = `${parts[1]}.${parts[0]}`; // 只取最后两个部分
  return domain;
}

function getCookieOptions() {

  if (isLocal()) {
    return {
      expires: 1
    }
  } else {
    return {
      expires: 1,
      domain: getDomain()
    }
  }

}


export const setDomainToken = (token: string, tokenKey = DOMAIN_TOKEN_KEY) => {
  Cookies.set(tokenKey, token, getCookieOptions());
};